const breakpointM = 1000;

export { breakpointM };
